import React, { Component } from 'react';

class FreezingDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Resampling and freezing tracks offer ways of recording the full project or a particular track, for one loop.
              </p>
              <p className="sub-header">
                Resampling a Project
              </p>
              <p>
                In order to resample the project, click on the red <b>Resample</b> button at the bottom of the sequencer page.
              </p>
              <p className="sub-header">
                Freezing a Track
              </p>
              <p>
                Freezing a track resamples the track, along with 
                any effects, into a new sample. This frees up your CPU, which is useful
                for tracks with complex effects chains. It freezes based
                on the current pattern.
              </p>
              <p>
                To freeze a track, click the colored circle on the bottom right of a track. It will
                record the current pattern. Once finished, there will be a box with all your frozen tracks
                that you can play.
              </p>
              <p className="sub-header">
                Unfreeze a Track
              </p>
              <p>
                You can unfreeze a track to go back to the original track. To do this, click the "Unfreeze" button.
              </p>
            </div>
        );
    }
}

export default FreezingDocumentation;
